const codeList = {
    ACH: 'ACH',
    CREDIT_CARD_EXP: 'creditCardExp',
    CREDIT_CARD_AUTH: 'creditCardAuth',
    MULTI_PAY_CHANGE: 'multiPayChange',
    PON4300: 'Pon4300',
    LINEPNP: 'linePnp',
};
Object.freeze(codeList);
export default codeList;
